import { AssertException } from '../assert.exception';

export class AssertIsArrayException extends AssertException {
  constructor(message?: string) {
    super(message);

    Object.setPrototypeOf(this, AssertIsArrayException.prototype);
  }
}
